export default {
  adherentsCorrespondant: {
    search: {
      actif: 'Actif',
      nom: 'Nom',
      prenom: 'Prénom',
      idParticipant: 'Identifiant',
    },
  },
  bilansCorrespondant: {
    search: {
      etatBilan: 'État bilan',
      dateDebutBilan: 'Date début (1er RDV)',
      dateFinBilan: 'Date fin (1er RDV)',
    },
    button: {
      print: 'Télécharger',
    },
  },
  adherents: {
    tooltip: {
      export: 'Exporter',
    },
    overview: "Détail d'un adhérent",
    search: {
      actif: 'Actif',
    },
    list: {
      title: 'Adhérents',
      headers: {
        id: 'Identifiant',
        civilite: 'Civilité',
        name: 'Nom Et prénom',
        dateDeNaissance: 'Date de naissance',
        mail: 'Email',
        mutation: 'Mutation ?',
        bilan: 'Bilan en cours',
      },
    },
    bilans: {
      title: 'Bilans',
      historique: {
        title: 'Historique des bilans',
      },
      list: {
        headers: {
          id: 'Identifiant',
          name: 'Nom et prénom',
          dateDeNaissance: 'Date de naissance',
          age: 'Âge',
          dateAdhesion: "Date d'adhésion",
          dateResiliation: 'Date de résiliation',
          gestionRDV: 'Gestion du rdv',
          periodicite: 'Périodicité',
          dateBilan: 'Date du bilan',
          datePremierRDV: 'Date du premier RDV',
          etatBilan: 'État du bilan',
          dateBilanN2: 'Bilan clos N-2',
          dateBilanN1: 'Bilan clos N-1',
          dateBilanN0: 'Bilan clos N',
          dateProchainBilan: 'Bilan en cours / programmé',
          dateCloture: 'Date de cloture',
          dateFacturation: 'Date de facturation',
        },
      },
    },
    fetch: {
      error: "Impossible de récupérer l'adhérent depuis essenciem",
      coordonnee: {
        error:
          "Impossible de récupérer les coordonnées de l'adhérent depuis essenciem",
      },
      dateMammo: {
        error:
          "Impossible de récupérer la date de dernière mammographie de l'adhérent depuis essenciem",
      },
    },
    save: {
      error: "Erreur technique à la sauvegarde de l'adhérent",
    },
    mutation: {
      error: 'Erreur technique pendant la mutation du participant',
    },
    principal: {
      fetch: {
        error:
          "Impossible de récupérer les informations principales de l'adhérent dans Essenciem",
      },
    },
  },
  extraciem: {
    participant: {
      bloque:
        'Veuillez essayer la modification ultérieurement, la fiche est bloquée actuellement par le système ESSENCIEM pour modification et/ou consultation',
    },
  },
  participant: {
    notfound: "Le participant n'a pas été trouvé",
    readherer: 'Réadhérer le participant',
    resilier: 'Radier le participant',
    muter: {
      action: 'Muter',
      title: 'Mutation du participant',
      message: 'Confirmez-vous que vous souhaitez muter le participant ?',
      etablissementDestination: 'Établissement de destination',
      priseEnChargeBilanEnCours:
        "Prise en charge du bilan en cours par l'établissement de destination ? Le bilan reste facturé à l'établissement actuel tant que la demande de mutation n'est pas validée",
    },
    gestionDesistement:
      'Je suis intéressé(e) pour avancer mon rendez-vous en cas de désistement',
    details: {
      id: 'Identifiant',
      afterCreation: 'Après création',
      fermerFenetre: 'Fermer La fenêtre',
      nom: 'Nom',
      prenom: 'Prénom',
      name: 'Participant',
      nomJeuneFille: 'Nom de naissance',
      nomPhonetique: 'Nom phonétique',
      genre: {
        label: 'Sexe',
        male: 'Homme',
        female: 'Femme',
      },
      dateDeNaissance: 'Né le',
      lieuNaissance: 'à',
      dateEcheance: "Date d'échéance",
      status: {
        actif: 'Actif',
        inactif: 'Inactif',
      },
      profession: 'Profession',
      fonction: 'Fonction',
      numTelephone: 'Numéro de téléphone',
      gsm: 'Numéro de téléphone portable',
      mail: 'Adresse mail',
      adresse: 'Adresse de réception de toute correspondance CIEM',
      pays: "Pays d'exercice",
      provenance: 'Provenance',
      codePostal: 'Code postal',
      birthDate: 'Né le: ',
      etablissementLabel: 'Établissement',
      etablissementId: "Numéro d'établissement",
      etablissementRaisonSociale: "Raison sociale de l'établissement",
      categorie: 'Catégorie',
      expirationDate: "Date d'echeance",
      bilanCounter: 'Nombre de bilan effectués',
      dateAdhesion: "Date d'adhésion",
      dateResiliation: 'Date de résiliation',
      datePremiereAdhesion: '1ère Adhésion',
      civilite: 'Civilité',
      coordonnee: 'Coordonnées',
      contact: 'Contact',
      telFixe: 'Téléphone fixe',
      telPortable: 'Téléphone portable',
      telSecretariat: 'Tél. Secrétariat',
      passerParAssistante: "Passer par l'assistante",
      parleQueAnglais: 'Anglais uniquement',
      gestionnaire: {
        message:
          'Pour modifier les informations inactives à la saisie, veuillez contacter : <br>{0} <br>Par téléphone : {1} <br>Par mail : {2} ',
        partelephone: 'Par téléphone : ',
        parmail: 'Par mail : ',
      },
      gesRDV: 'Gestion RDV',
      typeBilan: 'Bilan habituel',
      dateProchainBilan: 'Date du prochain bilan',
      periodiciteBilan: 'Périodicité du bilan',
      info4: 'Info participant',
      utiliserAdresseEtablissement: "Utiliser l'adresse de l'établissement",
      informationPaysExercice:
        "Les bilans expatriés ne sont possible que pour les pays à risque définis par l'OMS",
    },
    rendezvous: {
      debut: 'Début du RDV',
      fin: 'Fin du RDV',
      ajouter: 'Ajouter',
      objet: 'Type de la visite',
      cardiologue: 'Cardiologue',
      interniste: 'Interniste',
      gynecologue: 'Gynécologue',
      statut: 'Statut de la visite',
      bilanEnCours: 'Bilan en cours',
    },
    resiliation: {
      motif: 'Motif de radiation',
      resilie: 'Le participant a été radié',
      bilanEC: 'Erreur: le participant a un bilan en cours',
      bilanECTitle: 'Participants avec un bilan en cours',
      bilansEC:
        'Opération impossible: un ou plusieurs participants ont un bilan en cours. Voulez-vous afficher la liste ?',
      participantsActifs:
        'Opération impossible: un ou plusieurs participants sont encore actifs. Voulez-vous les radier après ?',
      error: 'Erreur lors de la radiation',
      saisieMotifResiliation: 'Saisir le motif de la résiliation',
    },
    error: {
      bilan: {
        encours:
          'Vous ne pouvez pas radier ce participant car il a un bilan en cours',
      },
      readherer: {
        doublons:
          'Vous ne pouvez pas réadhérer ce participant, il existe un autre participant avec les mêmes informations, veillez contacter le CIEM',
      },
      muter: {
        etablissementDestinataireIdentique:
          "Erreur: L'établissement de destination est identique à l'établissement source",
        demandeEnCours: 'Il y a déjà une mutation en cours',
      },
    },
    readhesion: {
      success: 'Le participant a été réadhéré avec succès',
    },
    extraciem: {
      bloque:
        'Veuillez essayer la modification ultérieurement, la fiche est bloquée actuellement par le système ESSENCIEM pour modification et/ou consultation',
    },
    update: {
      success: 'Mise à jour effectuée avec succès',
    },
    create: {
      doublons:
        'Vous ne pouvez pas créer ce participant, il existe un autre participant avec les mêmes informations, veillez contacter le CIEM',
      success: 'Le participant a été crée avec succès',
      correspondant: {
        notfound: "Le correspondant n'a pas été trouvé",
        unauthorized: 'Vous avez pas les droits pour effectuer cette action',
        entrepiseNotfound:
          "L'établissement du rattachement du correspondant effectuant la création n'a pa été trouvé",
        error:
          "Une erreur technique a eu lieu pendant la création du participant. Veuillez contacter le support pour plus d'informations",
      },
    },
    bilanEnCours: 'Bilan en cours',
    alertContact:
      'Le numéro de téléphone mobile que vous avez saisi ne semble pas correct',
    alertTypeBilan:
      'La modification du type de bilan est impossible car un bilan est en cours, veuillez contacter le CIEM',
    attention: 'Attention',
    demandeMutationEnCours: 'Demande de mutation en cours',
    coordonneesperso: {
      update: {
        error:
          'Une erreur a eu lieu pendant la mise à jour des coordonnées personnelles',
      },
    },
    mutation: {
      accordRefus: {
        incompatible:
          "L'établissement de destination ne prend pas en charge le type de bilan réalisés par ce participant",
      },
    },
    essenciem: {
      create: {
        error: 'Impossible de créer un participant dans Essenciem',
      },
    },
    alertDeconnexion:
      'Vos informations de connexion ont changé, veuillez vous reconnecter avec vos nouveaux identifiants.',
  },
  adresse: {
    saisie: "Saisie d'adresse",
    ligne1: {
      particulier: {
        label: 'Destinataire',
        placeholder: 'Civilité ou titre / Prénom / Nom',
      },
      etablissement: {
        label: 'Raison sociale ou dénomination commerciale',
      },
    },
    ligne2: {
      particulier: {
        label: 'Point de remise',
        placeholder:
          "N° d'appartement ou de boîte à lettre / Etage / Couloir / Escalier",
      },
      etablissement: {
        label: 'Destinataire ou service',
        placeholder: 'Identité du destinataire ou service',
      },
    },
    ligne3: {
      label: 'Complément de localisation',
      particulier: {
        placeholder: 'Immeuble / Résidence',
      },
      etablissement: {
        placeholder: 'Immeuble / Résidence / Zone industrielle',
      },
    },
    numeroVoie: 'N° de voie',
    typeVoie: 'Type de voie',
    nomVoie: 'Nom de voie',
    ligne5: {
      label: 'Service de distribution / Complément de localisation de la voie',
      particulier: {
        placeholder: 'Poste restante / BP / Lieu-dit',
      },
      etablissement: {
        placeholder: 'BP / TSA',
      },
    },
    codePostal: 'Code postal',
    localite: {
      particulier: 'Localité',
      etablissement: 'Localité et Cedex',
    },
    pays: 'Pays',
  },
}
